import { app } from '../../../../../app';

app.component('companyUserDirectoriesSaaspassUsersRegularSaaspassAppUsers', {
    bindings: {
        regularUsers: '<',
		labels: '<',
        numberOfUsers: '<',
    },
    templateUrl: require('./regular-saaspass-app-users.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/regular-saaspass-app-users/regular-saaspass-app-users.component.js